import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import s from "./PreDistributionTelekino.module.css";
import PreDistributionDetail from "./Detail/PreDistributionDetail";

import { useTranslation } from "react-i18next";
import { dateFormats } from "../../../../helpers/convertDate";
import ConfigsSearcher from "../../../../config/Configs";
import UploadModal from "./UploadModal";
import PanelDistribucionTelekino from "../PanelDistribucionTelekino";
import Pager from "../../../Shared/Pagination/Pagination";
import Swal from "sweetalert2";

import CircularProgress from "@mui/material/CircularProgress"
import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Tooltip from "@mui/material/Tooltip"
import IconButton from '@mui/material/IconButton'
import CachedIcon from '@mui/icons-material/Cached';
import CircleIcon from '@mui/icons-material/Circle';

import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import VisibilityIcon from '@mui/icons-material/Visibility';
import UploadRoundedIcon from "@mui/icons-material/UploadRounded";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import masiveDistributionServices from "../../../../api/delivery/masiveDistribution";
import useTranslationException from "../../../../helpers/exceptions";

const FILE_STATUS = {
  ACTIVE: "Activo",
  PENDING: "Pendiente",
  IN_PROCESS: "En Proceso",
  PROCESSED: "Procesado",
  DELETED: "Eliminado"
}

// ====================== | PRE DISTRIBUTION TELEKINO | ========================

const PreDistributionTelekino = () => {
  const dates = dateFormats();

  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const { textColor } = useSelector((state) => state.local);

  const [telekinoCuit, setTelekinoCuit] = useState(null);

  const [items, setItems] = useState([]);
  const [itemDetail, setItemDetail] = useState({
    data: null,
    active: false,
  });
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState({
    status: false,
    archive: {},
  });
  const [loadingDelete, setLoadingDelete] = useState({
    id: 0,
    status: false,
  });

  const [loadingConfirm, setLoadingConfirm] = useState({
    id: 0,
    status: false,
  });

  const callFiles = () => {
    setLoading(true);
    masiveDistributionServices
      .getTelekinoFiles(page, pageSize, sort)
      .then((res) => {
        setItems(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false))
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  };

  const verifyTelekinoCuit = () => {
    const telekinoConfig = configFinder("TELEKINO_FILE_CUIT");
    if (telekinoConfig) {
      setTelekinoCuit(telekinoConfig);
    }
    return !!telekinoConfig;
  };

  const { configFinder } = ConfigsSearcher();

  //pager
  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState({
    field: "processedDate",
    criteria: "DESC",
  });
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: ".9rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  const handleSort = (name) => {
    setSort((prev) => ({
      criteria:
        prev.field === name
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: name,
    }));
  };

  const handleDetail = (item) => {
    setItemDetail({
      data: item,
      active: true,
    });
  };

  const handleEdit = (item) => {
    setEdit({
      status: true,
      archive: item,
    });
  };

  const handleDelete = (item) => {
    setLoadingDelete({
      id: item.id,
      status: true,
    });
    Swal.fire({
      title: `${t("deleteFile")}`,
      text: `${t("deleteTelekinoText")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00A36C",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        masiveDistributionServices
          .deletePreDistributionFile(item.id)
          .then(() => {
            Swal.fire(
              t("successDeleteTelekinoTitle"),
              t("successDeleteTelekinoText"),
              "success",
            ).then(() => {
              callFiles();
              setLoadingDelete({
                id: 0,
                status: false,
              });
            });
          })
          .catch((e) => {
            Swal.fire(t("retry"), t("sorryErrorOcurred"), "error").then(() => {
              setLoadingDelete({
                id: 0,
                status: false,
              });
            });
          });
      } else {
        setLoadingDelete({
          id: 0,
          status: false,
        });
      }
    });
  };

  useEffect(() => {
    if (verifyTelekinoCuit()) {
      callFiles();
    } else {
      Swal.fire(
        t("configurationNotFound"),
        t("noTelekinoSupplierFoundError"),
        "error",
      );
    }
  }, [page, pageSize, sort]);

  const handleConfirm = async (id) => {
    setLoadingConfirm(() => {
      return {
        status: true,
        id: id
      }
    })

    masiveDistributionServices
      .postPreDistributionValidate(id)
      .then(() => {
        setLoadingConfirm((prev) => ({ ...prev, status: false }))
        callFiles()
      })
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        )
        setLoadingConfirm((prev) => ({ ...prev, status: false }))
      })
  }

  return (
    <Grid container className={s.container}>
      {telekinoCuit ? (
        edit.status ? (
          <PanelDistribucionTelekino
            data={edit}
            setEdicion={setEdit}
            callFiles={callFiles}
          />
        ) : itemDetail.active ? (
          <PreDistributionDetail data={itemDetail.data} setData={setItemDetail} />
        )
          : (
            <>
              <Grid item container xs={11} className={s.header}>
                <Grid item xs={12} lg={5} md={8} className={s.titleContainer}>
                  <LocalShippingIcon
                    sx={{ fontSize: "2rem", color: "primary.main" }}
                  />
                  <h4>{t("Pre-DistributionTelekino")}</h4>
                </Grid>
                <Grid item xs={12} lg={2} md={3}>
                  <Tooltip placement="top" title={t("uploadFile")}>
                    <Button
                      variant="contained"
                      className={s.uploadBtn}
                      onClick={() => setOpen(true)}
                    >
                      <UploadRoundedIcon sx={{ fontSize: "2rem" }} />
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
              {loading ? (
                <Grid item xs={11} className={s.loader}>
                  <CircularProgress size={"3rem"} />
                </Grid>
              ) : items?.length ? (
                <Grid item container xs={11} className={s.data}>
                  <TableContainer className={s.tableContainer}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              fontSize: ".9rem",
                              fontWeight: 500,
                              fontFamily: "Roboto, sans-Serif",
                            }}
                            onClick={() => handleSort("processedFile")}
                          >
                            {`${t("drawNumber")} ${sort.field === "processedFile" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                          </TableCell>
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              fontSize: ".9rem",
                              fontWeight: 500,
                              fontFamily: "Roboto, sans-Serif",
                            }}
                            onClick={() => handleSort("processedDate")}
                          >
                            {`${t("processDate")} ${sort.field === "processedDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                          </TableCell>
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              fontSize: ".9rem",
                              fontWeight: 500,
                              fontFamily: "Roboto, sans-Serif",
                            }}
                            onClick={() => handleSort("fileCouponsQty")}
                          >
                            {`${t("preDistTotalCoupons")} ${sort.field === "fileCouponsQty" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                          </TableCell>
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              fontSize: ".9rem",
                              fontWeight: 500,
                              fontFamily: "Roboto, sans-Serif",
                            }}
                            onClick={() => handleSort("fileItemsQty")}
                          >
                            {`${t("numberRecords")} ${sort.field === "fileItemsQty" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              fontSize: ".9rem",
                              fontWeight: 500,
                              fontFamily: "Roboto, sans-Serif",
                            }}
                            onClick={() => handleSort("status")}
                          >
                            {`${t("state")} ${sort.field === "status" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                          </TableCell>
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              fontSize: ".9rem",
                              fontWeight: 500,
                              fontFamily: "Roboto, sans-Serif",
                            }}
                            align="center"
                          >
                            {t("view")}
                          </TableCell>
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              fontSize: ".9rem",
                              fontWeight: 500,
                              fontFamily: "Roboto, sans-Serif",
                            }}
                            align="center"
                          >
                            {t("confirm")}
                          </TableCell>
                          <TableCell
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                              fontSize: ".9rem",
                              fontWeight: 500,
                              fontFamily: "Roboto, sans-Serif",
                            }}
                            align="center"
                          >
                            {t("delete")}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {items.map((item, i) => {
                          return (
                            <React.Fragment key={item.id}>
                              <TableRow
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "secondary.light",
                                  },
                                }}
                              >
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                  onClick={() => handleDetail(item)}
                                >
                                  {item?.raffleNumber}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                  onClick={() => handleDetail(item)}
                                >
                                  {dates.formatDate(item.processedDate)}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                  onClick={() => handleDetail(item)}
                                >
                                  {item.fileCouponsQty}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                  onClick={() => handleDetail(item)}
                                >
                                  {item.fileItemsQty}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                  onClick={() => handleDetail(item)}
                                >
                                  {renderStatus(item.status)}
                                </TableCell>
                                <TableCell
                                  style={{ width: "10%" }}
                                  align="center"
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {item.status === "Procesado" ? (
                                    <VisibilityIcon
                                      sx={{
                                        color: "grey",
                                        fontSize: "1.8rem",
                                        cursor: "not-allowed",
                                      }}
                                    />
                                  ) : (
                                    <IconButton
                                      onClick={() => handleEdit(item)}
                                    >
                                      <VisibilityIcon
                                        className={s.iconbtn}
                                        sx={{ color: "primary.dark", fontSize: "1.8rem" }}
                                      />
                                    </IconButton>
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{ width: "10%" }}
                                  align="center"
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {loadingConfirm.status &&
                                    loadingConfirm.id === item.id ? (
                                    <CircularProgress size={"2rem"} />
                                  ) : item.status === "Activo" ? (
                                    <IconButton
                                      sx={{ display: "flex", alignItems: "start" }}
                                    >
                                      <CachedIcon />
                                    </IconButton>
                                  ) : (
                                    <IconButton onClick={() => handleConfirm(item.id)} >
                                      <CachedIcon color="primary" sx={{ fontSize: "1.8rem" }} />
                                    </IconButton>
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{ width: "10%" }}
                                  align="center"
                                  sx={{
                                    ...cellStyles,
                                    backgroundColor:
                                      i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                  }}
                                >
                                  {loadingDelete.status &&
                                    loadingDelete.id === item.id ? (
                                    <CircularProgress size={"2rem"} />
                                  ) : item.status === "Pendiente" ? (

                                    <IconButton
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%"
                                      }}
                                      onClick={() => handleDelete(item)}
                                    >
                                      <DeleteForeverRoundedIcon
                                        className={s.iconbtn}
                                        sx={{ color: "primary.dark" }}
                                      />
                                    </IconButton>
                                  ) : (

                                    <IconButton
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%"
                                      }}
                                      disabled
                                    >
                                      <DeleteForeverRoundedIcon
                                        sx={{
                                          color: "grey",
                                          fontSize: "1.8rem",
                                          cursor: "not-allowed",
                                        }}
                                      />
                                    </IconButton>
                                  )}
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mb: "50px",
                    }}
                  >
                    <Pager
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageCustom={pageCustom}
                      setPageCustom={setPageCustom}
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12} className={s.noResults}>
                  {t("noResults")}
                </Grid>
              )}
              {open ? (
                <UploadModal
                  open={open}
                  setOpen={setOpen}
                  setEdit={setEdit}
                  callFiles={callFiles}
                  cuit={telekinoCuit}
                />
              ) : null}
            </>
          )
      ) : (
        <Grid item xs={12} className={s.noResults}>
          {t("noTelekinoSupplierFoundError")}
        </Grid>
      )}
    </Grid>
  );
};

export default PreDistributionTelekino;

// ============================= | UTILS | =====================================

/* It renders an icon colored depending on the status
 * @param {string} status - A string that represent the status
 * */
const renderStatus = (status) => {
  let sColor = null;
  let current = null;

  switch (status) {
    case FILE_STATUS.ACTIVE:
      sColor = "forestGreen"
      current = FILE_STATUS.ACTIVE
      break;
    case FILE_STATUS.PENDING:
      sColor = "gold"
      current = FILE_STATUS.PENDING
      break;
    case FILE_STATUS.IN_PROCESS:
      sColor = "orange"
      current = FILE_STATUS.IN_PROCESS
      break;
    case FILE_STATUS.PROCESSED:
      sColor = "MidnightBlue"
      current = FILE_STATUS.PROCESSED
      break;
    case FILE_STATUS.DELETED:
      sColor = "DarkRed"
      current = FILE_STATUS.DELETED
      break;
    default:
      sColor = "DarkSlateBlue"
      current = FILE_STATUS.ACTIVE
  }

  return (
    <Tooltip title={current} >
      <CircleIcon sx={{ color: sColor }} />
    </Tooltip>
  )
}
